import React from "react";
import styles from "./Rewards.module.css";
import {
  FaTrophy,
  FaIndustry,
  FaExclamationCircle,
  FaAward,
  FaMedal,
  FaCertificate,
} from "react-icons/fa";

const Rewards = () => {
  return (
    <div className={styles.rewardsBG}>
      <div className={styles.rewards}>
        <div className={styles.rewardsHeader}>
          <h2 className={styles.headerTitle}>
            Rewards & Recognition of{" "}
            <span className={styles.highlightIRL}>IRL top performers</span>
          </h2>
        </div>

        <div className={styles.championsSection}>
          <div className={styles.championCategories}>
            <div key={1} className={styles.championCard}>
              <div className={styles.iconWrapper}>
                <FaTrophy />
              </div>
              <h4 className={styles.cardTitle}>Overall Champions - Seniors</h4>
              <p className={styles.cardDescription}>
                25,000 INR worth Robotics
              </p>
              <p className={styles.cardDescription}>
                Kits for overall champions
              </p>
            </div>

            <div key={2} className={styles.championCard}>
              <div className={styles.iconWrapper}>
                <FaTrophy />
              </div>
              <h4 className={styles.cardTitle}>Overall Champions - Juniors</h4>
              <p className={styles.cardDescription}>
                20,000 INR worth Robotics
              </p>
              <p className={styles.cardDescription}>
                Kits for overall champions
              </p>
            </div>
          </div>

          <div className={styles.industrialVisit}>
            <p className={styles.visitText}>
              <div className={styles.highlightColor}>
                <FaAward />
              </div>
              All champions will have the incredible opportunity to participate
              in an Industrial Visit, engaging directly with Tech and R&D Teams
              to showcase their projects in real-world scenarios to corporate
              leaders.
            </p>
          </div>
        </div>

        <div className={styles.placementRewards}>
          <div className={styles.rewardsHeader}>
            <h2 className={styles.headerTitle}>
              Rewards & Recognition of{" "}
              <span className={styles.highlightIRL1}>
                IRL for 1st, 2nd & 3rd Place
              </span>
            </h2>
          </div>
          <div className={styles.championsSection}>
            <div className={styles.championCategories}>
              <div key={1} className={styles.championCard1}>
                <div className={styles.iconWrapper1}>
                  <FaTrophy />
                </div>
                <h4 className={styles.cardTitle}>Trophy</h4>
              </div>

              <div key={2} className={styles.championCard1}>
                <div className={styles.iconWrapper1}>
                  <FaMedal />
                </div>
                <h4 className={styles.cardTitle}>Medals</h4>
              </div>

              <div key={3} className={styles.championCard1}>
                <div className={styles.iconWrapper1}>
                  <FaCertificate />
                </div>
                <h4 className={styles.cardTitle}>Certificate</h4>
              </div>
            </div>
          </div>
          <p className={styles.note}>
            *Note: Winning teams will not receive a certificate of
            participation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Rewards;
